import { Box, Container, Divider, Group, Stack, TextInput, Title } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo, useState } from "react";
import { StickyHeader } from "~/components/sticky-header";
import { trpc } from "~/lib/trpc";
import { CreateUser } from "./-components/create-user";
import { User } from "./-components/user";

export const Route = createFileRoute("/_authenticated/admin/users/")({
  component: RouteComponent,
  loader: async ({ context: { queryClient, trpc } }) => {
    const users = await queryClient.ensureQueryData(trpc.admin.users.getList.queryOptions());
    return { users };
  },
});

function RouteComponent() {
  const loaderData = Route.useLoaderData();
  const users = useQuery({
    ...trpc.admin.users.getList.queryOptions(),
    initialData: loaderData.users,
  });
  const [searchTerm, setSearchTerm] = useState("");

  const usersToDisplay = useMemo(() => {
    if (!users.data) return [];
    return users.data.filter((user) => {
      const searchTermLc = searchTerm.trim().toLowerCase();
      if (
        searchTermLc &&
        !(user.name.toLowerCase().includes(searchTermLc) || user.email.toLowerCase().includes(searchTermLc))
      ) {
        return false;
      }
      return true;
    });
  }, [users.data, searchTerm]);

  return (
    <Box>
      <StickyHeader bg="dark.7">
        <Container p="md" pb={0}>
          <Group justify="space-between">
            <Group>
              <Title order={3}>Users</Title>
              <TextInput
                placeholder="Search users"
                leftSection={<IconSearch color="var(--mantine-color-gray-4)" />}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.currentTarget.value)}
              />
            </Group>
            <CreateUser />
          </Group>
          <Divider size={1} my="md" />
        </Container>
      </StickyHeader>
      <Container>
        <Stack gap={0} my="sm">
          {usersToDisplay.map((user) => (
            <User user={user} key={user.id} />
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
